import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  template: '<router-outlet />',
})
export class App implements OnInit {
  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);
    const sidebarCollapsed = params.get('sidebarCollapsed');
    if (sidebarCollapsed !== null) {
      try {
        localStorage.setItem('re_sidebar_collapsed', sidebarCollapsed);
      } catch {
        /* ignore */
      }
    }
    if (params.has('userId') || sidebarCollapsed !== null) {
      window.history.replaceState({}, '', window.location.pathname);
    }
  }
}
